module.exports = __webpack_public_path__ + "img/004.a1115669.png";